import { Color, ListTemplate } from '@amcharts/amcharts4/core';
import { XYSeries, XYSeriesDataItem } from '@amcharts/amcharts4/charts';
import _sum from 'lodash/sum';
import _sortBy from 'lodash/sortBy';

export const mapSeriesListToLegendItems = (
    seriesList: ListTemplate<XYSeries> | null,
): QRRLegendTableItem[] => {
    if (seriesList === null) {
        return [];
    }

    const tableItems = seriesList.values.reduce(
        (
            itemsAcc: QRRLegendTableItem[],
            series: XYSeries,
        ): QRRLegendTableItem[] => {
            const color = series?.fill instanceof Color ? series.fill : null;
            const { mainDataSet, name } = series;

            if (name === undefined) {
                return itemsAcc;
            }

            const earnings = mainDataSet.values.reduce(
                (earningsAcc: number[], item: XYSeriesDataItem): number[] => {
                    if (typeof item?.valueY === 'number') {
                        earningsAcc.push(item.valueY);
                    }

                    return earningsAcc;
                },
                [],
            );

            itemsAcc.push({
                color,
                entityName: name,
                mostRecentEarnings: earnings?.[earnings.length - 1] ?? 0,
                series,
                totalEarnings: _sum(earnings),
            });

            return itemsAcc;
        },
        [],
    );

    return _sortBy(tableItems, 'entityName');
};
